import React from 'react';

export default function HomeTopServices({ bestServices, onServiceClick }) {
  return (
    <section className="section top-services" aria-labelledby="top-services-title">
      <div className="section-heading" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
        <p className="eyebrow dark" style={{ marginBottom: '8px' }}>Top Services</p>
        <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'flex-end', gap: '24px' }}>
          <h2 id="top-services-title" className="dh-title-2" style={{ margin: 0 }}>
            High-demand support from the live DALMAF offering
          </h2>
        </div>
      </div>
      <div className="compact-grid">
        {bestServices?.length > 0 ? (
          bestServices.map((data, index) => (
            <article key={index} style={{ cursor: 'pointer' }} onClick={onServiceClick(data)}>
              <span className="compact-label">
                {data.mainServiceName}
                {data.subServiceL1Name ? ` - ${data.subServiceL1Name}` : ''}
              </span>
              <strong className="compact-title">{data.title}</strong>
            </article>
          ))
        ) : (
          <>
            <article><span className="compact-label">Audit - Startup</span><strong className="compact-title">Appointment of Director</strong></article>
            <article><span className="compact-label">Audit - Startup</span><strong className="compact-title">Sole Proprietorship Registration</strong></article>
            <article><span className="compact-label">Audit - Income Tax</span><strong className="compact-title">ITR-6 Return Filing</strong></article>
            <article><span className="compact-label">Legal - Criminal Case</span><strong className="compact-title">Session Criminal Case Significance</strong></article>
            <article><span className="compact-label">Legal - Motor Vehicle</span><strong className="compact-title">Motor Vehicle Accident Significances</strong></article>
            <article><span className="compact-label">Legal - FEMA</span><strong className="compact-title">Foreign Exchange Maintenance Act</strong></article>
          </>
        )}
      </div>
    </section>
  );
}
